import React, { useState } from 'react';

import DeleteAccountModal from './DeleteAccountModal';

interface DeleteAccountButtonProps {

}

const DeleteAccountButton: React.FC<DeleteAccountButtonProps> = () => {
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const onClick = () => {
        setIsDeleteModalVisible(true);
    };
    return (
        <div className="">
            <div
                onClick={onClick}
                className="bg-red-600 text-white px-4 py-2 text-sm rounded-md hover:bg-red-700"
            >
                Delete Account
            </div>
            <DeleteAccountModal visible={isDeleteModalVisible} onClose={() => setIsDeleteModalVisible(false)} onDelete={() => {}} />
        </div>
    );
};

export default DeleteAccountButton;